// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"281":"SecondBonusRoundRoute","514":"ThirdBonusRoundRoute","586":"FirstBonusRoundRoute"}[chunkId] || chunkId) + "." + {"281":"90fa3473","514":"727d9a8b","586":"5a6b4649","787":"8d4ce1b4"}[chunkId] + ".chunk.js";
};